import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { authwsEnvironment } from '../authws-environment';
import { switchedAccountUserSchema } from '../schemas/switched-account-user.schema';

/**
 * Requests a User object of a particular user other than the one making the request
 * @param authToken The current user's auth token
 * @param product The product where the switch is taking place
 * @param alias The alias of the account being switched into
 * @returns The User who was switched into
 */
export function postSecurityAccountSwitch(
  this: unknown,
  request: {
    alias: string;
    authToken: string;
    product: string;
  }
) {
  return fromFetch(
    new Request(authwsEnvironment.resolve(this).securityAccountSwitchUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
        ...new AuthHeaders(),
      },
      body: JSON.stringify(request),
    })
  ).pipe(selectData(switchedAccountUserSchema));
}
